import React from 'react';
import { ReferralWithScope_UserWithoutId } from '../../helpers/DataStructures';
import ReferralConversationDetail from './ReferralConversationDetail';

interface ReferralOutDetailContentProps {
  referral: ReferralWithScope_UserWithoutId;
  showCounterpartyHeader?: boolean;
}

const ReferralOutDetailContent: React.FC<ReferralOutDetailContentProps> = ({
  referral,
  showCounterpartyHeader = true,
}) => (
  // REQ-001: remount the conversation when referral id changes so drafts and old messages reset.
  <ReferralConversationDetail
    key={referral.id}
    referral={referral}
    showCounterpartyHeader={showCounterpartyHeader}
  />
);

export default ReferralOutDetailContent;
